import React, { useEffect, useState } from 'react'
import {
  Row,
  Col,
  Card,
  Button,
  Image,
  Select,
  Input,
  Form,
  message,
  Modal,
  Checkbox,
  DatePicker,
  InputNumber,
} from 'antd'
import '../../css/regimen.scss'
import {
  EditOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  PlusCircleOutlined,
  ExclamationCircleFilled,
  DeleteFilled,
  CheckCircleFilled,
  CheckCircleOutlined,
} from '@ant-design/icons'

import '../../css/schedule.scss'
import moment from 'moment'
import { constants } from '../../constants'
import util from '../../util/util'
import ProgressGoalsModal from '../schedule/progress.goals.modal'

const DeviceCard = ({
  handleRemoveClick,
  device,
  isEdited,
  changeSchedule,
  patient,
  changeScheduleToAll,
  changeScheduleAndSkipToAll,
  hideButtons,
  buttonHide,
  editpage,
  progressGoals,
  onProgressGoalsChange,
}) => {
  var [editDevice, setEditDevice] = useState(false)
  var [applyAll, setApplyAll] = useState(false)
  var [skiponsurgerydate,setSkip] = useState(device.scheduled_criteria?.skiponsurgerydate)
  // The TracPatch row opens a modal (schedule dates + Progress-Test weekly goal
  // overrides + patient avatar) instead of the inline date editor.
  var [showGoalsModal, setShowGoalsModal] = useState(false)
  const isTracPatch = !!(
    (device.device_type &&
      String(device.device_type).toLowerCase() === 'tracpatch') ||
    (device.display_name &&
      String(device.display_name).toLowerCase().includes('tracpatch'))
  )

  const handleGoalsModalSave = (criteria, overrides) => {
    setShowGoalsModal(false)
    changeSchedule({
      ...device,
      scheduled_criteria: { ...criteria, skiponsurgerydate },
      isNew: false,
    })
    if (onProgressGoalsChange) onProgressGoalsChange(overrides)
    isEdited()
  }

  const dailyTimes = [
    'morning',
    'morning, evening',
    'morning, afternoon, evening',
    'morning, afternoon, evening, night',
  ]

  const diff = moment(Date.now())
    .startOf('day')
    .diff(moment(patient?.surgery?.date).startOf('day'), 'days')

  useEffect(() => {
    if (device.isNew == true) {
      setEditDevice(device.isNew)
    }
  }, [])
  useEffect(() => setSkip(device.scheduled_criteria.skiponsurgerydate),[device])
  useEffect(() => hideButtons(editDevice), [editDevice])
  useEffect(() => {
    if (!buttonHide && editDevice) setEditDevice(false)
  }, [buttonHide])

  const handleSubmit = (e) => {
    if (e.start_date > e.end_date) {
      message.error('start date can be same or before end date')
      return
    }
    setEditDevice(false)
    changeSchedule({ ...device, scheduled_criteria: { ...e, skiponsurgerydate }, isNew: false });
    
    isEdited()
  }
  const removeDevice = (e, id) => {
    e.stopPropagation()
    showConfirmDeleteBox(id)
  }

  var showConfirmDeleteBox = (id) => {
    Modal.confirm({
      title: '',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure you want remove this device ?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        isEdited()
        hideButtons(false)
        handleRemoveClick(id)
      },
    })
  }

  var showConfirmeBox = (e) => {
    Modal.confirm({
      title: 'Are you sure you want apply this schedule to all ?',
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => handleSubmitAll(e),
    })
  }

  //confirmation box to update skip on surgery date status for all devices
  var showConfirmeBoxSkipForAll = (e) => {
    Modal.confirm({
      title: `Do you want apply 'Skip on surgery date' to all devices?`,
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => handleskiptoall(e),
      onCancel: () => handleSubmit(e),
    })
  }

  var handleskiptoall = (e) => {
    if (e.start_date > e.end_date) {
      message.error('start date can be same or before end date')
      return
    }
    setEditDevice(false)
    changeScheduleAndSkipToAll({...device, scheduled_criteria: { ...e, skiponsurgerydate }, isNew: false });

    isEdited()
  }

  var renderIntervalOptions = () => {
    return constants.INTERVAL_OPTIONS.map((data) => (
      <Select.Option value={data.index}>{data.name}</Select.Option>
    ))
  }
  var handleSubmitAll = (e) => {
    if (e.start_date > e.end_date) {
      message.error('start date can be same or before end date')
      return
    }
    setEditDevice(false)
    changeScheduleToAll({ ...device, scheduled_criteria: { ...e, skiponsurgerydate } })
    setApplyAll(false)
    isEdited()
  }

  var getDays = (date) =>
    moment(date)
      .startOf('day')
      .diff(moment(patient?.surgery?.date).startOf('day'), 'days')

  return (
    <Card id={'decschedcard'} bordered={false} className='noPadding'>
      <Row>
        <Col style={{ width: '100%' }}>
          {device ? (
            <Col className='assignedContainer'>
              <Row>
                <Row
                  className='selectorContainer'
                  gutter={25}
                  style={{ width: '100%' }}
                >
                  <Row className='connectorLine_1 devconnectorline' />
                  <Col className='exerciseColCenter divide' span={7}>
                    <Card bordered={false} className='deviceRow'>
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <Col className='noPadding'>
                          <div className='exerImgBox '>
                            <Image
                              className='exerImg '
                              src={device.media.image.url}
                            />
                          </div>
                        </Col>
                        <div className='exerRow '>
                          <Col className='exerHeader noPadding'>
                            {device.display_name}
                          </Col>
                        </div>
                      </div>
                    </Card>
                  </Col>
                  <Col className='exerciseColCenter divide ' span={13}>
                    <Card
                      bordered={false}
                      className='deviceRow'
                      style={{ maxWidth: '90%' }}
                    >
                      {editDevice ? (
                        <Col>
                          <Row style={{ height: '75px' }}>
                            <Form
                              layout={'vertical'}
                              style={{
                                display: 'flex',
                                width: '100%',
                                gap: '5px',
                                gap: '5px',
                              }}
                              onFinish={(e) => {
                                if (!e || e.start_date === undefined || e.end_date === undefined) {
                                  message.error(
                                    'start date or end date is missing'
                                  )
                                  return
                                }
                                if (editpage) {
                                  e.start_date = getDays(e.start_date)
                                  e.end_date = getDays(e.end_date)
                                }
                                applyAll ? showConfirmeBox(e) :skiponsurgerydate? showConfirmeBoxSkipForAll(e):  handleSubmit(e)
                              }}
                              initialValues={{
                                start_date: editpage
                                  ? moment(patient?.surgery?.date).add(
                                      device.scheduled_criteria?.start_date ,
                                      'd'
                                    )
                                  : device.scheduled_criteria?.start_date,
                                end_date: editpage
                                  ? moment(patient?.surgery?.date).add(
                                      device.scheduled_criteria?.end_date,
                                      'd'
                                    )
                                  : device.scheduled_criteria?.end_date,
                                time: device.scheduled_criteria?.time || '1',
                                interval:
                                  device.scheduled_criteria?.interval >= 0
                                    ? device.scheduled_criteria?.interval
                                    : 1 || 1,
                              }}
                            >
                              <Form.Item
                                label='Start'
                                className='formInput'
                                name='start_date'
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select start date.',
                                  },
                                  () => ({
                                    validator(rule, value) {
                                      if (!editpage)
                                        value = moment(
                                          patient?.surgery?.date
                                        ).add(parseInt(value, 10), 'days')
                                      console.log(value.format('MM/DD/YYYY'))
                                      if (
                                        moment(value)
                                          .startOf('day')
                                          .isSameOrAfter(
                                            moment().startOf('day')
                                          )
                                      ) {
                                        return Promise.resolve()
                                      }
                                      return Promise.reject(
                                        `select ${editpage ? 'date' : 'days'} ${editpage ? moment().add(diff).format('MM/DD/YYYY') : diff} or greater!`
                                      )
                                    },
                                  }),
                                ]}
                              >
                                {!editpage ? (
                                  <InputNumber
                                    type='number'
                                    style={{ minWidth: 68 }}
                                    required
                                  />
                                ) : (
                                  <DatePicker showToday={false} />
                                )}
                              </Form.Item>
                              <Form.Item
                                label='End'
                                className='formInput'
                                name='end_date'
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select end date.',
                                  },
                                  ({ getFieldValue }) => ({
                                    validator(rule, value) {
                                      let start = getFieldValue('start_date')
                                      if (!editpage) {
                                        value = moment(
                                          patient?.surgery?.date
                                        ).add(value)
                                        start = moment(
                                          patient?.surgery?.date
                                        ).add(start)
                                      }
                                      if (
                                        moment(value)
                                          .startOf('day')
                                          .isSameOrAfter(
                                            moment().startOf('day')
                                          ) &&
                                        moment(value)
                                          .startOf('day')
                                          .isSameOrAfter(start.startOf('day'))
                                      ) {
                                        return Promise.resolve()
                                      }
                                      return Promise.reject(
                                        `select ${editpage ? 'date' : 'days'} today or greater`
                                      )
                                    },
                                  }),
                                ]}
                              >
                                {!editpage ? (
                                  <InputNumber
                                    type='number'
                                    style={{ minWidth: 68 }}
                                    required
                                  />
                                ) : (
                                  <DatePicker showToday={false} />
                                )}
                              </Form.Item>
                              <Form.Item
                                label='Interval'
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select interval.',
                                  },
                                ]}
                                name='interval'
                              >
                                <Select
                                  showSearch
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                  style={{ minWidth: 120 }}
                                  defaultValue={1}
                                >
                                  {renderIntervalOptions()}
                                </Select>
                              </Form.Item>
                              <Form.Item label='Time' hidden={true} name='time'>
                                <Select
                                  showSearch
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                  defaultValue={'1'}
                                >
                                  <Select.Option value='1'>1</Select.Option>
                                  <Select.Option value='2'>2</Select.Option>
                                  <Select.Option value='3'>3</Select.Option>
                                  <Select.Option value='4'>4</Select.Option>
                                </Select>
                              </Form.Item>
                              <Button
                                style={{ all: 'unset' }}
                                type='button'
                                htmlType='submit'
                              >
                                <CheckCircleOutlined
                                  style={{ fontSize: '27px', margin: '10px' }}
                                  className='editIcon'
                                />
                              </Button>
                              <Button
                                style={{ all: 'unset' }}
                                onClick={() => {
                                  if (device.isNew)
                                    changeSchedule({ ...device, isNew: false })
                                  setEditDevice(false)
                                  setSkip(device.scheduled_criteria?.skiponsurgerydate)
                                }}
                              >
                                <CloseCircleOutlined
                                  style={{ fontSize: '27px' }}
                                  className='editIcon'
                                />
                              </Button>
                            </Form>
                          </Row>
                          <Row>
                            <Checkbox
                              style={{ marginLeft: '20%' }}
                              checked={skiponsurgerydate}
                              onChange={(e) => setSkip(e.target.checked)}
                            >
                              Skip on surgery date
                            </Checkbox>
                            <Checkbox
                              style={{ marginLeft: '4%' }}
                              value={applyAll}
                              onChange={() => setApplyAll(!applyAll)}
                            >
                              Apply to all
                            </Checkbox>
                          </Row>
                        </Col>
                      ) : (
                        <Col
                          style={{
                            height: '50px',
                            flexDirection: 'row',
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Col className='confHeader' flex={'auto'}>
                            <Row>
                              S
                              {device.scheduled_criteria?.start_date >= 0
                                ? '+' +
                                    device.scheduled_criteria?.start_date?.toString() ||
                                  '-15'
                                : device.scheduled_criteria?.start_date.toString() ||
                                  '-15'}
                            </Row>
                            <Row>
                              {moment(patient?.surgery?.date)
                                .add(device.scheduled_criteria?.start_date, 'd')
                                .format('MM/DD/YYYY')}
                            </Row>
                          </Col>
                          <Col className='confHeader' flex={'auto'}>
                            To
                          </Col>
                          <Col className='confHeader' flex={'auto'}>
                            <Row>
                              S
                              {device.scheduled_criteria?.end_date >= 0
                                ? '+' +
                                    device.scheduled_criteria?.end_date.toString() ||
                                  '+15'
                                : device.scheduled_criteria?.end_date.toString() ||
                                  '+15'}
                            </Row>
                            <Row>
                              {moment(patient?.surgery?.date)
                                .add(device.scheduled_criteria?.end_date, 'd')
                                .format('MM/DD/YYYY')}
                            </Row>
                          </Col>

                          <Row style={{ offset: '100%' }}>
                            <EditOutlined
                              id={'editdevice'}
                              style={{ fontSize: '20px' }}
                              hidden={buttonHide}
                              onClick={() =>
                                isTracPatch
                                  ? setShowGoalsModal(true)
                                  : setEditDevice(true)
                              }
                            />
                          </Row>

                          <Col> </Col>
                        </Col>
                      )}

                      {!editDevice && (
                        <p
                          className='confHeader'
                          style={{ paddingLeft: '24px', paddingTop: '5px' }}
                        >
                          {util.intervalOptions(
                            device.scheduled_criteria?.interval
                          )}
                          <br />
                          {/* Times : {dailyTimes[(device.scheduled_criteria?.time || 1)-1]}  */}
                        </p>
                      )}
                    </Card>
                  </Col>
                  <Col span={4}>
                    {' '}
                    <Card
                      id={'deletedevice'}
                      style={{ display: 'flex', justifyContent: 'center' }}
                      className='deviceRow'
                      align='middle'
                    >
                      <DeleteFilled
                        style={{ fontSize: '25px' }}
                        onClick={(e) => removeDevice(e, device._id)}
                      />
                    </Card>
                  </Col>
                </Row>
              </Row>
            </Col>
          ) : null}
        </Col>
      </Row>
      {isTracPatch && showGoalsModal && (
        <ProgressGoalsModal
          visible={showGoalsModal}
          patient={patient}
          editpage={editpage}
          initialCriteria={device.scheduled_criteria}
          initialOverrides={progressGoals}
          onCancel={() => setShowGoalsModal(false)}
          onSave={handleGoalsModalSave}
        />
      )}
    </Card>
  )
}
export default DeviceCard
